/**
 * Recommended products CTA
 * Below ₹25L: Short-Term → One Stock | Long-Term → Jarvis Portfolio
 * Above ₹25L: India → Jarvis Prime | US → Jarvis US Multi Asset
 */

export const EXPLORE_PRODUCTS = [
  {
    key: "us",
    titleWhite: "JARVIS US",
    titleAccent: "Multi Asset",
    accent: "#0980FA",
    border: "#9EC5FF",
    cardBg: "#00010D",
    buttonBg: "linear-gradient(90deg, #05234F 0%, #0D6BF5 100%)",
    buttonLabel: "Start Jarvis US Multi Asset",
    href: "/customer/product-info/us-strategy",
    image: "/images/phc-dashboard/explore-us.png",
    checkIcon: "/images/phc-dashboard/explore-check-us.svg",
    underline: "/images/phc-dashboard/explore-underline-us.svg",
    imageLayout: {
      left: { xs: 160, md: 178 },
      top: { xs: 92, md: 44 },
      size: { xs: 228, md: 300 },
      opacity: 0.8,
    },
    contentWidth: { xs: 200, md: 322 },
    bullets: [
      "Access to a Diversified U.S. Multi-Asset Portfolio",
      "Built-In U.S. Dollar Exposure",
      "Institutional-Grade Portfolio Construction",
      "Seamless Automated Execution",
      "AI-Driven Active Portfolio Management",
    ],
  },
  {
    key: "atlas",
    titleWhite: "JARVIS Atlas",
    titleAccent: "",
    accent: "#B3592B",
    border: "#9EC5FF",
    cardBg: "#00010D",
    buttonBg: "linear-gradient(90deg, #531C00 0%, #B3592B 100%)",
    buttonLabel: "Start Jarvis Atlas",
    href: "/customer/product-info/atlas",
    image: "/images/phc-dashboard/explore-atlas.png",
    checkIcon: "/images/phc-dashboard/explore-check-atlas.svg",
    underline: "/images/phc-dashboard/explore-underline-atlas.svg",
    imageLayout: {
      left: { xs: 150, md: 164 },
      top: { xs: 70, md: 34 },
      size: { xs: 210, md: 312 },
      opacity: 1,
    },
    contentWidth: { xs: 200, md: 238 },
    bullets: [
      "Coverage across 10+ Global markets",
      "Structured Ideas: Entry, Stop loss, & Rationale",
      "Coverage of equities, commodities & ETF's",
      "Weekly global market intelligence report",
    ],
  },
  {
    key: "prime",
    titleWhite: "JARVIS Prime",
    titleAccent: "",
    accent: "#FDBD1B",
    border: "#9EC5FF",
    cardBg: "#010100",
    buttonBg: "linear-gradient(90deg, #553D00 0%, #FDBD1B 100%)",
    buttonLabel: "Start Jarvis Prime",
    href: "/customer/product-info/prime",
    image: "/images/phc-dashboard/explore-prime.png",
    checkIcon: "/images/phc-dashboard/explore-check-prime.svg",
    underline: "/images/phc-dashboard/explore-underline-prime.svg",
    imageLayout: {
      left: { xs: 140, md: 128 },
      top: { xs: 40, md: 8 },
      size: { xs: 230, md: 350 },
      opacity: 0.9,
    },
    contentWidth: { xs: 200, md: 255 },
    bullets: [
      "A hyper-personalized portfolio in Indian markets",
      "Actively managed by AI",
      "Dedicated wealth advisor support",
      "Access to weekly global market report",
    ],
  },
];

export const LONG_TERM_PRODUCT = {
  badge: "Switch to AI Portfolio with Jarvis",
  titleJarvis: "JARVIS",
  titleProduct: "PORTFOLIO",
  titleColor: "#7C3AED",
  subtitle: "Long Term Recommendations",
  listTitle: "What your portfolio data flag?",
  bullets: [
    "AI-Powered Portfolio Construction",
    "Dynamic Portfolio Rebalancing",
    "Diversification With AI Intelligence",
    "Personalized To Your Risk Appetite",
  ],
  rangeTitle: "Investment Range",
  rangeText:
    "Up to ₹25L – AI managed equity portfolio with full transparency and regular rebalancing",
  cta: "Start Investing",
  href: "/customer/product-info/portfolio",
  panelBg: "linear-gradient(135deg, #F5F0FF 0%, #EDE4FF 100%)",
  badgeBg: "#7C3AED",
  bulletColor: "#7C3AED",
  rangeBorder: "#C4B5FD",
  buttonBg: "linear-gradient(90deg, #6D28D9 0%, #4F46E5 100%)",
  image: "/images/phc-dashboard/recommend-portfolio.png",
};

export const INDIA_PRIME_PRODUCT = {
  key: "prime",
  badge: "Switch to AI Portfolio with Jarvis",
  titleJarvis: "JARVIS",
  titleProduct: "PRIME",
  titleColor: "#F3A220",
  subtitle: "Long Term Recommendations",
  listTitle: "What your portfolio data flag?",
  bullets: [
    "AI-Powered Portfolio Construction",
    "Dynamic Portfolio Rebalancing",
    "Diversification with AI Intelligence",
    "Personalized to Your Risk Appetite",
  ],
  rangeTitle: "Investment Range",
  rangeText:
    "Up to ₹25L - AI managed equity portfolio with full transparency and regular rebalancing",
  cta: "Start Investing",
  href: "/customer/product-info/prime",
  panelBg:
    "linear-gradient(158.62deg, rgba(242, 160, 30, 0.41) 8.4%, rgba(255, 255, 255, 0) 64.8%)",
  badgeBg: "linear-gradient(90deg, #EB7E06 0%, #F9BC33 100%)",
  bulletColor: "#F3A220",
  rangeBorder: "#F6A823",
  rangeBg: "rgba(246,168,35,0.13)",
  buttonBg: "linear-gradient(90deg, #A15603 0%, #F9BB32 100%)",
  image: "/images/phc-dashboard/recommend-prime.png",
};

export const US_MULTI_ASSET_PRODUCT = {
  key: "us",
  badge: "Invest across US assets with AI",
  titleJarvis: "JARVIS",
  titleProduct: "US Multi Asset",
  titleColor: "#0D6BF5",
  subtitle: "Short Term Recommendations",
  listTitle: "What you Unlock",
  bullets: [
    "Access to a Diversified U.S. Multi Asset Portfolio",
    "Built In U.S. Dollar Exposure",
    "Institutional Grade Portfolio Construction",
    "Seamless Automated Execution",
    "AI Driven Active Portfolio Management",
  ],
  rangeTitle: "US Multi Asset. Smarter Allocation",
  rangeText:
    "Get AI-driven allocation across multiple US asset classes to optimize risk and returns.",
  cta: "Start Investing",
  href: "/customer/product-info/us-strategy",
  panelBg:
    "linear-gradient(90deg, rgba(13, 107, 245, 0.16) 51.5%, rgba(255, 255, 255, 0) 100%)",
  badgeBg: "linear-gradient(90deg, #001533 0%, #0D6BF5 100%)",
  bulletColor: "#0D6BF5",
  rangeBorder: "#032760",
  rangeBg: "rgba(150,188,245,0.09)",
  buttonBg: "linear-gradient(90deg, #001E4B 0%, #106AEF 100%)",
  image: "/images/phc-dashboard/recommend-us.png",
};

export const SHORT_TERM_PRODUCT = {
  badge: "Get AI Recommendation on One Stock",
  titleJarvis: "JARVIS",
  titleProduct: "ONE STOCK",
  titleColor: "#2563EB",
  subtitle: "Short Term Recommendations",
  listTitle: "Why check this stock with Jarvis?",
  bullets: [
    "AI Driven Stock Calls – High Probability Opportunity Identified Daily.",
    "Clear Entry, Target & Exit – Buy Price, Buy Range, Target Price, & Stoploss All Available In The App",
    "Timely & Actionable – Real Time Buy & Sell Alerts With 24*7 Stock Monitoring",
  ],
  rangeTitle: "One Stock. AI Clarity",
  rangeText:
    "Get In depth AI analysis and recommendation for a single stock that matters to you.",
  cta: "Start Investing",
  href: "/customer/product-info/onestock",
  panelBg: "linear-gradient(135deg, #EFF6FF 0%, #DBEAFE 100%)",
  badgeBg: "#1E3A8A",
  bulletColor: "#2563EB",
  rangeBorder: "#93C5FD",
  buttonBg: "linear-gradient(90deg, #1E3A8A 0%, #1D4ED8 100%)",
  image: "/images/phc-dashboard/recommend-onestock.png",
};

// export const DEFAULT_INSIGHT = {
//   recommendation: "High Concentration in Top 10 Stocks",
//   estimatedSellCalls: "₹15,00,000",
// };

export const DEFAULT_INSIGHT = {
  recommendation: "—",
  estimatedSellCalls: "—",
};

/** Placeholder until `phc/health-check/portfolio-review` is published. */
export const DUMMY_PORTFOLIO_REVIEW = {
  protection: {
    title: "Protection",
    summary:
      "The portfolio carries above-average market sensitivity with a beta of 1.19, but the Sortino ratio of 12.71 confirms that downside risk is better controlled than raw volatility implies.",
    content:
      "With a **max drawdown of -16.88%**, a **daily risk of 8.83%**, and **annual volatility of 84.93%** rated Poor, the portfolio is exposed to sharp short-term swings amplified by its **beta of 1.19**. Reduce the outsized **41.9% position in LT** to below 20% and consider allocating 5–8% to a gold ETF or liquid defensive instrument to buffer downside.",
  },
  optimization: {
    title: "Optimization",
    summary:
      "The portfolio is efficiently converting downside risk into returns, as evidenced by a Sortino of 12.71 and Calmar of 7.8, though concentration is capping the Sharpe ratio at a moderate 1.47.",
    content:
      "Outperforming the Nifty 50 by **+12.4%** and Nifty 500 by **+7.0%** validates the stock selection, yet the **top 5 holdings commanding 80.9%** of weight suppresses risk-adjusted efficiency across the portfolio. Introduce a **10–15% mid-cap allocation** by trimming top winners like TITAN (+52.5%) and ADANIENT (+32.48%) partially and deploying into uncorrelated mid-cap names to close the rebalancing gap.",
  },
  personalization: {
    title: "Personalization",
    summary:
      "The portfolio is a pure large-cap construct with zero mid-cap, small-cap, or ETF exposure, creating a lopsided risk profile dominated by Capital Goods and Financial sectors.",
    content:
      "With **100% large-cap allocation** and **41.86% concentrated in a single Capital Goods stock (LT)**, sector diversification is critically thin, while INFY is actively destroying value at **-29.62%** on a **₹58,000 buy value**. Exit or reduce INFY below a 2% weight and redeploy the freed capital into a mid-cap fund or a high-conviction sector like Healthcare, where SUNPHARMA already shows a stable **+9.71% gain** with low risk.",
  },
};
